import { render } from "./SendNewMessage.vue?vue&type=template&id=e56f7a8e"
import script from "./SendNewMessage.vue?vue&type=script&lang=js"
export * from "./SendNewMessage.vue?vue&type=script&lang=js"

import "./SendNewMessage.vue?vue&type=style&index=0&id=e56f7a8e&lang=css"

import exportComponent from "C:\\Users\\HanYaqoob\\Desktop\\REPOS\\DebtCrmPortalUI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__